import { render, staticRenderFns } from "./Drive.vue?vue&type=template&id=20d0d5ce&scoped=true&"
import script from "./Drive.vue?vue&type=script&lang=js&"
export * from "./Drive.vue?vue&type=script&lang=js&"
import style0 from "./Drive.vue?vue&type=style&index=0&id=20d0d5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0d5ce",
  null
  
)

export default component.exports